export default __webpack_public_path__ + "static/media/nationalIdIT.228c66de.jpg";